import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import AccountActivated from './components/AccountActivated'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/activated" element={<AccountActivated />} />
        {/* Add other routes here */}
      </Routes>
    </Router>
  );
}

export default App;
